export default "__VITE_ASSET__dff9aaec__"